import { useContext } from 'react';
import { useMutation, useQuery } from '@apollo/client';
import { AppContext } from '@edx/frontend-platform/react';

import {
  DELETE_TICKET,
  GET_TICKET_BY_ID,
  GET_USER_TICKETS,
  INSERT_TICKET,
  INSERT_TICKET_COMMENT,
} from '../queries/tickets';

export const useFetchUserTickets = () => {
  const { authenticatedUser } = useContext(AppContext);
  const userId = authenticatedUser?.userId ?? authenticatedUser?.id;

  const {
    data, loading, error, refetch,
  } = useQuery(GET_USER_TICKETS, {
    variables: { userId },
    skip: !userId,
    fetchPolicy: 'cache-and-network',
  });

  return {
    tickets: data?.tickets || [],
    loading,
    error,
    refetch,
  };
};

export const useFetchTicketById = (ticketId) => {
  const {
    data, loading, error, refetch,
  } = useQuery(GET_TICKET_BY_ID, {
    variables: { ticketId },
    skip: !ticketId,
    fetchPolicy: 'cache-and-network',
  });

  return {
    ticket: data?.ticketsById || null,
    loading,
    error,
    refetch,
  };
};

export const useInsertTicket = () => {
  const [insertTicket, { loading, error }] = useMutation(INSERT_TICKET);
  return { insertTicket, loading, error };
};

export const useInsertTicketComment = () => {
  const [insertTicketComment, { loading, error }] = useMutation(INSERT_TICKET_COMMENT);
  return { insertTicketComment, loading, error };
};

export const useDeleteTicket = () => {
  const [deleteTicket, { loading, error }] = useMutation(DELETE_TICKET);
  return { deleteTicket, loading, error };
};
